import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { Eyebrow, Reveal } from "../Reveal";
import { FAQS } from "../../data/site";

export const Faq = () => (
  <section id="faq" data-testid="faq-section" className="section-pad bg-warm">
    <div className="container-cando grid gap-14 lg:grid-cols-12">
      <div className="lg:col-span-5">
        <div className="lg:sticky lg:top-32">
          <Reveal>
            <Eyebrow>Common Questions</Eyebrow>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="h2 mt-6 max-w-md text-charcoal">Questions Homeowners Ask.</h2>
          </Reveal>
          <Reveal delay={0.16}>
            <p className="body-lg mt-6 max-w-md text-mute">
              Straight answers about our services, estimates and how projects get started.
            </p>
          </Reveal>
        </div>
      </div>

      <div className="lg:col-span-7">
        <Reveal delay={0.1}>
          <Accordion type="single" collapsible data-testid="faq-accordion" className="border-t border-charcoal/15">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-b border-charcoal/15">
                <AccordionTrigger
                  data-testid={`faq-question-${i}`}
                  className="py-6 text-left font-heading text-[17px] font-semibold text-charcoal hover:text-bronze hover:no-underline"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent data-testid={`faq-answer-${i}`} className="pb-6 text-[16px] leading-relaxed text-mute">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </div>
  </section>
);
